import { queryClient } from "App";
import { get } from "lodash";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  getInvestigationStatusesTableColumns,
  getInvestigationStatusesTableFilters,
} from "routes/investigation_status/components/InvestigationStatusesTableColumnsAndFilters";
import { INVESTIGATION_STATUSES_TABLE_CONSTANTS } from "routes/investigation_status/InvestigationStatusesTableV3";
import UserService from "services/User";
import { addResizedColumns } from "./useTableConfig";

export const invalidateInvestigationStatusesTableQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [INVESTIGATION_STATUSES_TABLE_CONSTANTS.queryKey],
  });
};

export const useInvestigationStatusesTable = ({ tableName = null }) => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const filters = useMemo(() => {
    return getInvestigationStatusesTableFilters();
  }, []);

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getInvestigationStatusesTableColumns();

    const investigationStatusesTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: investigationStatusesTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableName, tableSettings, isTableSettingsFetched]);

  return { filters, columns };
};
